<template>
  <OmtRow
    :desktopEnd="12"
    border="0.5px solid var(--colors-light-secondary-divider)"
    border-radius="8px"
    mt="16px"
    py="19px"
    px="16px"
    style="display: flex; flex-direction: column"
  >
    <CBox v-if="hasRequest && !isOmintRequest">
      <CFlex mb="15px" align-items="center" style="justify-content: space-between">
        <CFlex>
          <img :src="IconUser" alt="" />
          <OmtTypography as="h2-bold" font-size="14px"> Sua solicitação </OmtTypography>
        </CFlex>
        <OmtTypography as="p1" color="#8C8C8C" font-size="14px">{{ createdAt }}</OmtTypography>
      </CFlex>
      <div :class="{ pontilhado: hasResponses }">
        <CFlex :ps="hasResponses ? '28px' : '40px'" mb="16px">
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)" font-size="14px">
            {{ description }}
          </OmtTypography>
        </CFlex>
        <CFlex ps="40px" mb="16px" v-if="pictures.length">
          <CGrid w="100%" :templateColumns="['repeat(auto-fill, minmax(56px, 1fr))']">
            <ImagePreviewer
              v-for="(picture, index) in pictures"
              :key="index"
              v-bind="picture"
              :source="picture.source"
            />
          </CGrid>
        </CFlex>
      </div>
    </CBox>

    <CBox v-if="hasResponses">
      <div v-for="(response, idx) in responses" :key="`resp-${idx}`">
        <CFlex mb="15px" align-items="center" style="justify-content: space-between">
          <CFlex>
            <img :src="IconOmint" alt="" :style="`visibility: ${idx != 0 ? 'hidden' : ''}`" />
            <OmtTypography as="h2-bold" font-size="14px">
              {{ isOmintRequest ? "Solicitação Omint" : "Resposta Omint" }}
            </OmtTypography>
          </CFlex>

          <OmtTypography as="p1" color="#8C8C8C" font-size="14px">{{ response.DataResposta }}</OmtTypography>
        </CFlex>
        <CFlex ps="40px">
          <OmtTypography as="p1" font-size="14px">{{ getResponseText(response) }}</OmtTypography>
        </CFlex>
        <hr v-if="responses.length > 1 && idx % 2 == 0" class="divider" />
      </div>
    </CBox>

    <slot name="additional-content" />
  </OmtRow>
</template>

<script>
import ImagePreviewer from "@/components/Molecules/ImagePreviewer";

export default {
  name: "RequestResponseCard",
  components: {
    ImagePreviewer
  },
  props: {
    description: {
      type: String,
      default: ""
    },
    createdAt: {
      type: String,
      default: ""
    },
    pictures: {
      type: Array,
      default: () => []
    },
    responses: {
      type: Array,
      default: () => []
    },
    containerClass: {
      type: String,
      default: ""
    },
    containerStyle: {
      type: [String, Object],
      default: "display: flex; flex-direction: column"
    },
    isOmintRequest: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasRequest() {
      return !!(this.description?.trim() || this.pictures?.length);
    },
    hasResponses() {
      return this.responses?.length > 0;
    },
    IconUser() {
      return process.env.VUE_APP_BASE_URL + "images/Group3303.png";
    },
    IconOmint() {
      return process.env.VUE_APP_BASE_URL + "images/Group3305.png";
    }
  },
  methods: {
    getResponseText(response) {
      if (typeof response === "string") {
        return response;
      }
      if (response && response.Resposta) {
        return response.Resposta;
      }
      return String(response);
    }
  }
};
</script>

<style scoped>
img {
  margin-right: 16px;
}
.pontilhado {
  overflow: auto;
  margin-left: 10px;
  border-left: 1px dashed #8c8c8c;
  margin-bottom: 10px;
}
.resp {
  margin-left: 40px;
}

.divider {
  border-bottom: 1px solid #dadada;
  margin-top: 16px;
  width: 90%;
  margin-left: auto;
  margin-bottom: 16px;
}
</style>
